export const SENTRY_FILTERS = [
  /Couldn't resolve component/gm,
  /Unexpected token '<'/gm,
  /Importing a module script failed./gm,
  /Object.hasOwn is not a function/gm,
  /r.isUnstyled is not a function/gm,
  /undefined is not an object \(evaluating 'i\._\$instances\[e\]'\)/gm
];
